__turbopack_context__.v({
  "actions": "analytics-consent-module__uJa8QW__actions",
  "banner": "analytics-consent-module__uJa8QW__banner",
  "preferences": "analytics-consent-module__uJa8QW__preferences",
});
